import { IsNotEmpty, IsBoolean } from "class-validator";

export class ScoreCheckInDto {
  @IsNotEmpty()
  @IsBoolean()
  checked_in: boolean;
}
